import { render, staticRenderFns } from "./kitAssembly.vue?vue&type=template&id=6a632d70&scoped=true&"
import script from "./kitAssembly.vue?vue&type=script&lang=js&"
export * from "./kitAssembly.vue?vue&type=script&lang=js&"
import style0 from "./kitAssembly.vue?vue&type=style&index=0&id=6a632d70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a632d70",
  null
  
)

export default component.exports